import { useAuthStore } from "@/stores/auth-store";
import { hasPermission, hasBackendPermission, type Permission } from "@/lib/permissions";

export function usePermission(permission: Permission): boolean {
  const role = useAuthStore((s) => s.user?.role);
  const grantedPermissions = useAuthStore((s) => s.experience?.grantedPermissions ?? []);
  if (grantedPermissions.length > 0) {
    return hasBackendPermission(grantedPermissions, permission);
  }
  return hasPermission(role, permission);
}

export function usePermissions(permissions: Permission[], mode: "any" | "all" = "any"): boolean {
  const role = useAuthStore((s) => s.user?.role);
  const grantedPermissions = useAuthStore((s) => s.experience?.grantedPermissions ?? []);
  const check = grantedPermissions.length > 0
    ? (p: Permission) => hasBackendPermission(grantedPermissions, p)
    : (p: Permission) => hasPermission(role, p);
  if (mode === "all") {
    return permissions.every(check);
  }
  return permissions.some(check);
}

export function useCurrentRole(): string | null {
  return useAuthStore((s) => s.user?.role ?? null);
}
